import BaseService from "@client.services/baseService";

export default class MicrosoftService extends BaseService {
  constructor() {
    super("microsoft", true);
  }
}
